import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, computed, watch } from "vue";
  import { useStore } from "vuex";
  import { POSITION, useToast } from "vue-toastification";
  import ChartForReports from "@/components/reports/ChartForReports.vue";
  import { EstateInterface } from "@/types/EstateInterface";
  import { LotStatusByReportWithCount } from "@/types/AnalyticsLotStatusInterface";
  import { ChartsTypes } from "@/enums/ChartsTypes";
  import { LotStatus } from "@/enums/LotStatus";
  import {
    getUniqueLotStatusArrayWithCount,
    getTotalByLotStatusArrayWithCount,
    getTotalDataLots,
    getSortedUniqueEstateTitle,
    getStatusByEstate,
  } from "@/helpers/lotStatus";
  import {
    optionsBarChartForWebsiteAnalytics,
    backgroundColorForLots,
    chartBackgroundColorForLots,
  } from "@/constants/optionsChart";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'LotStatusCount',
  props: {
    startDate: {
      type: String,
      required: true,
    },
    endDate: {
      type: String,
      required: true,
    },
    searchKey: {
      type: Number,
      required: true,
    },
    estateSelected: {
      type: String,
      required: true,
    },
  },
  setup(__props, { expose: __expose }) {
  __expose();

  const props = __props;

  const store = useStore();
  const toast = useToast();
  const loading = ref(false);

  const lotsStatusByReport = ref<LotStatusByReportWithCount[]>([]);
  const lotStatusOptions = [
    LotStatus.NOT_RELEASED,
    LotStatus.AVAILABLE,
    LotStatus.HOLD,
    LotStatus.PRE_CONTRACT,
    LotStatus.UNDER_CONTRACT,
    LotStatus.UNCONDITIONAL,
    LotStatus.SETTLED,
    LotStatus.OPTION,
    LotStatus.OFFLINE,
  ];

  const landownerId = computed(() => store.state.user.data._id);

  const startDateSelected = computed(() => {
    return props.startDate;
  });

  const endDateSelected = computed(() => {
    return props.endDate;
  });

  const estateSelected = computed(() => {
    return props.estateSelected;
  });

  watch(
    () => props.searchKey,
    () => {
      getlotStatus();
    }
  );

  const getlotStatus = () => {
    loading.value = true;

    if (landownerId.value) {
      store
        .dispatch("analytics/getLotStatus", {
          landownerId: landownerId.value,
          startDate: startDateSelected.value,
          endDate: endDateSelected.value,
          estateSelected: estateSelected.value,
        })
        .then((res) => {
          lotsStatusByReport.value = res.data;
        })
        .catch((err) => {
          toast.error("Error getting lot status", {
            position: POSITION.TOP_LEFT,
          });
        })
        .finally(() => {
          loading.value = false;
        });
    }
  };

  const uniqueLotStatusArray = computed(() =>
    getUniqueLotStatusArrayWithCount(lotsStatusByReport.value)
  );
  const totalByLotStatusArray = computed(() =>
    getTotalByLotStatusArrayWithCount(
      lotsStatusByReport.value,
      uniqueLotStatusArray.value
    )
  );
  const totalDataLots = computed(() =>
    getTotalDataLots(totalByLotStatusArray.value)
  );
  const sortedUniqueEstateTitle = computed(() =>
    getSortedUniqueEstateTitle(lotsStatusByReport.value)
  );
  const statusByEstate = computed(() =>
    getStatusByEstate(lotsStatusByReport.value, sortedUniqueEstateTitle.value)
  );

  onMounted(() => {
    getlotStatus();
  });

const __returned__ = { props, store, toast, loading, lotsStatusByReport, lotStatusOptions, landownerId, startDateSelected, endDateSelected, estateSelected, getlotStatus, uniqueLotStatusArray, totalByLotStatusArray, totalDataLots, sortedUniqueEstateTitle, statusByEstate, ref, onMounted, computed, watch, get useStore() { return useStore }, get POSITION() { return POSITION }, get useToast() { return useToast }, ChartForReports, get EstateInterface() { return EstateInterface }, get LotStatusByReportWithCount() { return LotStatusByReportWithCount }, get ChartsTypes() { return ChartsTypes }, get LotStatus() { return LotStatus }, get getUniqueLotStatusArrayWithCount() { return getUniqueLotStatusArrayWithCount }, get getTotalByLotStatusArrayWithCount() { return getTotalByLotStatusArrayWithCount }, get getTotalDataLots() { return getTotalDataLots }, get getSortedUniqueEstateTitle() { return getSortedUniqueEstateTitle }, get getStatusByEstate() { return getStatusByEstate }, get optionsBarChartForWebsiteAnalytics() { return optionsBarChartForWebsiteAnalytics }, get backgroundColorForLots() { return backgroundColorForLots }, get chartBackgroundColorForLots() { return chartBackgroundColorForLots } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})